import React, { useState } from 'react';
import {
  TypedUseSelectorHook,
  useSelector as useReduxSelector,
} from 'react-redux';
import { Navigate, useParams } from 'react-router';

import { faMinusCircle } from '@fortawesome/pro-regular-svg-icons/faMinusCircle';

import { RootState } from '../../../../app/rootReducer';
import { IconLink } from '../../../../common/components/IconLink';
import { Resource } from '../../../../common/constants/resource';
import { tasksResolved } from '../../../../common/helpers';
import { IneligibleDrawer } from '../../../detail/drawer/ineligible/IneligibleDrawer';
import { InvalidDrawer } from '../../../detail/drawer/InvalidDrawer';
import { ITask } from '../../../tasks/interfaces/ITask';
import { getAllTasks } from '../../../tasks/slice/taskListSlice';

export const useSelector: TypedUseSelectorHook<RootState> = useReduxSelector;

const IneligibleForDecision = () => {
  const tasks: ITask[] = useSelector(state => getAllTasks(state.taskList));

  const copy = 'Ineligible for decision';

  // For controlling the IneligibleDrawer component
  const [isOpen, setIsOpen] = useState(false);
  const isValid = tasksResolved(tasks);

  const { id } = useParams<{ id: string }>();
  if (id === undefined) {
    return <Navigate to={{ pathname: '/' }} />;
  }

  return (
    <>
      {!isValid && (
        <InvalidDrawer
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          labelCopy={Resource.INELIGIBLE_APPLICATION_HEADER}
        />
      )}
      {isValid && (
        <IneligibleDrawer
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          applicationId={id}
        />
      )}
      <IconLink
        onClick={(evt: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
          evt.preventDefault();
          setIsOpen(true);
        }}
        icon={faMinusCircle}
        copy={copy}
      />
    </>
  );
};

export default IneligibleForDecision;
